<template>
  <div class="guide">
    <div class="top">
        <div class="menu">
            <div class="logo">
                <img src="~@/img/logo.png">
                <span>野马软件访客指引</span>
            </div>
            <div class="list">
                <ul>
                    <li @click="guide('/xuzhou')">
                        <span class="title">徐 州</span>
                        <span class="line"></span>
                        <span class="adress">徐州市云龙区绿地蓝海B座2402室</span>
                        <img class="arrow-left" src="~@/img/arrow-left.png">
                    </li>
                     <li @click="guide('/nanjing')">
                        <span class="title">南 京</span>
                        <span class="line"></span>
                        <span class="adress">南京市雨花区花神大道23号院5号楼418室</span>
                        <img class="arrow-left" src="~@/img/arrow-left.png">
                    </li>
                     <li @click="guide('/kejijia')">
                        <span class="title">盐 城</span>
                        <span class="line"></span>
                        <span class="adress">盐城市盐南高新区博通产业园5号楼1栋</span>
                        <img class="arrow-left" src="~@/img/arrow-left.png">
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer">
            <img src="~@/img/footer.png">
        </div>
    </div>
  </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
// const $ = window.jQuery;
// const img1 = defaultSettings.url + '/assets/product/p1.png'
export default {
  components: {
  },
  data() {
    return {
      url: defaultSettings.url,
    };
  },
  mounted() {
    window.scrollTo({ left: 0, top: 0 })
  },
  created(){
    this.wxShare()
    const newPageTitle = '江苏野马软件科技有限公司';
    document.querySelector('title').textContent = newPageTitle;
  },
  methods:{
    guide(obj) {
        this.$router.push({
            path: obj
        })
    },
    wxShare() {
        const url = encodeURIComponent(window.location.href.split('#')[0])
        this.$http.get(`https://server.yemast.com/wxPay/getSignature?url=${url}`).then(function(res){
            
            console.log(res)
            const result = res.data.result
            const appId = result.appId;
            const noncestr = result.noncestr;
            const signature = result.signature;
            const timestamp = result.timestamp;
          if (res.data.code === 200) {
               window.wx.config({
                debug: false,
                // 是否开启调试模式
                appId: appId,
                //appid
                timestamp: timestamp,
                // 时间戳
                nonceStr: noncestr,
                // 随机字符串
                signature: signature,
                // 签名
                jsApiList:
                    [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareWeibo',
                    'onMenuShareQZone'
                    ]
                // 需要使用的JS接口列表
                })
              window.wx.ready(()=> {
                // 分享给好友
                wx.onMenuShareAppMessage({
                    title: '欢迎您访问野马软件', // 分享标题
                    desc: '徐州总部、南京分公司、盐城分公司', // 分享描述
                    link: 'https://yemast.com/guide', // 分享链接
                    imgUrl: 'https://grammar.oss-cn-qingdao.aliyuncs.com/online/image/notework/assets/logoShare.png', // 分享图标
                    success:  ()=> {
                    doShareDone()
                    },
                    cancel:  ()=> {
                    doShareCancel()
                    }
                })

                // 分享到朋友圈
                wx.onMenuShareTimeline({
                   title: '欢迎您访问野马软件', // 分享标题
                    desc: '徐州总部、南京分公司、盐城分公司', // 分享描述
                    link: 'https://yemast.com/guide', // 分享链接
                    imgUrl: 'https://grammar.oss-cn-qingdao.aliyuncs.com/online/image/notework/assets/logoShare.png', // 分享图标
                    success:  ()=> {
                    doShareDone()
                    },
                    cancel:  ()=> {
                    doShareCancel()
                    }
                })
            })

            // 分享成功回调
            function doShareDone() {
                alert("分享成功")
                console.log("分享成功")
            }

            // 取消分享回调
            function doShareCancel() {
                console.log("取消了分享")
            }
          }
        }, function(){
        })
    }
  }
}
</script>

<style lang="less" scoped>
    .guide{
        span{
            display:inline-block;
        }
        .top{
            width:100%;
            min-height:78vh;
            background: url('~@/img/bg.png') no-repeat;
            background-size: 100% 100%;
            // position: fixed;
            padding-top:40%;
           
            .menu{
                background: #fff;
                // width:100%;
                height:100%;
                padding:3vh 5vw 1vh 5vw;
                margin:1% 4vw 0 4vw;
                border-radius: 30px;
                .logo{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img{
                        width:6vw;
                    }
                    span{
                        font-size:0.56rem;
                        color:#000;
                        font-family: Microsoft YaHei;
                        margin-left:3vw;
                        display: inline-block;
                    }
                }
                .list{
                    margin-top:2vh;
                    ul {
                        li{
                            background: #F9FAFC;
                            border: 2px solid #DCE1E7;
                            border-radius: 2vw;
                            padding:2.5vh 3vw;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-bottom:2vh;
                            .title{
                                color: #2B2A30;
                                font-size:0.45rem;
                                margin-right:1vw;
                                width:14vw;
                            }
                            .line{
                                width:1px;
                                height:3.5vh;
                                margin-right:3vw;
                                border-right:1px solid #DCE1E7;
                            }
                            .adress{
                                color:#2B2A30;
                                font-size:0.4rem;
                                margin-right:2vw;
                                line-height: 3.5vh;
                                width:65vw;
                            }
                            .arrow-left{
                                width:2vw;
                            }
                        }
                    }
                }
            }
            .footer{
                margin:13% auto 0;
                text-align: center;
                img{
                    height:5.1vh;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/guide.vue